import * as React from 'react';
import { TButtonSize } from '@cian/ui-kit/button/types';

import { ConsultantChatButtonContainer } from '../ConsultantChatButton';
import { useSelector } from 'react-redux';
import { selectConsultantMessageButtonAvailable } from '../../selectors/consultantChat';

interface ILeadFactoryMessageButtonContainerProps {
  buttonSize?: TButtonSize;
  icon?: JSX.Element;
  withOnboarding?: boolean;
}

export const LeadFactoryMessageButtonContainer: React.FC<ILeadFactoryMessageButtonContainerProps> = props => {
  const isAvailable = useSelector(selectConsultantMessageButtonAvailable);

  if (!isAvailable) {
    return null;
  }

  return <ConsultantChatButtonContainer {...props} />;
};
